/**
 * Calendar dates stored as YYYY-MM-DD — parse and display in local time so
 * values like 2026-08-08 are not shown as the previous day in US timezones.
 */

export function parseDateOnly(value) {
  if (value == null || String(value).trim() === "") return null;
  const raw = String(value).trim();
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    const d = new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (us) {
    const d = new Date(Number(us[3]), Number(us[1]) - 1, Number(us[2]));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/** Normalize to YYYY-MM-DD without UTC shifting. */
export function normalizeDateOnlyIso(value) {
  if (value == null || String(value).trim() === "") return "";
  const raw = String(value).trim();
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
  const us = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (us) {
    return `${us[3]}-${String(us[1]).padStart(2, "0")}-${String(us[2]).padStart(2, "0")}`;
  }
  const d = parseDateOnly(value);
  if (!d) return raw;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function formatDateOnlyDisplay(value, options) {
  const d = parseDateOnly(value);
  if (!d) {
    const s = value != null ? String(value).trim() : "";
    return s;
  }
  return d.toLocaleDateString(undefined, options);
}
